import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=0557224a&scoped=true"
import script from "./ImageUploadForm.vue?vue&type=script&lang=js"
export * from "./ImageUploadForm.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadForm.vue?vue&type=style&index=0&id=0557224a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0557224a",
  null
  
)

export default component.exports